module.exports = __webpack_public_path__ + "static/media/icon-supplies-toothpicks.9558098f.svg";